import { render } from "./CheckOutPage.vue?vue&type=template&id=3fc8f788"
import script from "./CheckOutPage.vue?vue&type=script&lang=js"
export * from "./CheckOutPage.vue?vue&type=script&lang=js"

import exportComponent from "/codebuild/output/src977627615/src/DSG-app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__